export declare interface SentryUser {
  id: string;
  username: string;
  email: string;
  ip_address: string;
};

const version:string = "{{BUILD_EMBED_LABEL}}";

interface Sentry {
  captureException(err:Error, context?:{[key:string]:any}):void;
  onLoad(f:()=>void):void;

  // These are only safe to call from Sentry.onLoad (or later).
  setContext(name:string, data:{[key:string]:any}):void;
  setTags(tags:{[key:string]:string}):void;
  setUser(user:Partial<SentryUser>):void;
  init(data:{[key:string]:any}):void;
}

function callSentry<K extends keyof Sentry>(key:K, ...args:Parameters<Sentry[K]>):void {
 const sentry = goog.global['Sentry'] as Sentry|undefined;
 if (sentry) {
  (sentry[key] as any)(...args);
 }
}

export const Sentry = {
  getReleaseName(prefix=''):string|undefined {
    if (version && !version.startsWith('{{')) {
      return `${prefix}${version}`;
    }
  },
  captureException(err:Error, context?:{[key:string]:any}) {
    callSentry('captureException', err, context);
  },
  setContext(name:string, data:{[key:string]:any}) {
    callSentry('setContext', name, data);
  },
  setTags(tags:{[key:string]:string}) {
    callSentry('setTags', tags);
  },
  setUser(user:Partial<SentryUser>){
    callSentry('setUser', user);
  },
  init(data:{[key:string]:any}){
    callSentry('init', data);
  },
  onLoad(f:()=>void){
    callSentry('onLoad', f);
  },
}